import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toEuros, toDate, estEnCoursDeChargement} from '../../App_Code/Utils';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import * as Actions from '../../Actions/GlobalActions';
import Chargement from '../Chargement';
import TableauV from '../TableauV';


function EnteteSimple() {

    return (
        <tr class="table-primary">
            <th scope="col">N° Compte</th>
            <th scope="col" className="td-separation">Nom du Compte</th>
            <th scope="col" className="text-right">
                Débit
            </th>
            <th scope="col" className="text-right td-separation">
                Crédit
            </th>
            <th scope="col" className="text-right">
                Solde Db
            </th>
            <th scope="col" className="text-right">
                Solde Cr
            </th>
        </tr>
    );
}

const LigneSimple = ({
    IdAgence, Cop, NomCop, DateDeb, DateFin, Niveau, Clas, SClas, Compte, Num, Code, CptInactifOk, Libelle, SDCOk, Db, Cr, SoldeDb, SoldeCr
}) => (
    
    <tr className={`${Niveau>1 ? 'tr-niv' + Niveau : ''}`}>
        <td>{Compte}</td>
        <td className="td-separation">{Libelle}</td>
        <td className="text-right text-nowrap">{toEuros(Db, false)}</td>
        <td className="text-right text-nowrap td-separation">{toEuros(Cr, false)}</td>
        {Niveau==1 ? <td className="text-right text-nowrap">{toEuros(SoldeDb, false)}</td> : ""}
        {Niveau!=1 && SoldeCr-SoldeDb<0 ? <td className="text-right text-nowrap">{toEuros(SoldeDb-SoldeCr, false)}</td> : ""}
        {Niveau!=1 && SoldeCr-SoldeDb>=0 ? <td className="text-right text-nowrap"></td> : ""}
        {Niveau==1 ? <td className="text-right text-nowrap">{toEuros(SoldeCr, false)}</td> : ""}
        {Niveau!=1 && SoldeCr-SoldeDb>0 ? <td className="text-right text-nowrap">{toEuros(SoldeCr-SoldeDb, false)}</td> : ""}
        {Niveau!=1 && SoldeCr-SoldeDb<=0 ? <td className="text-right text-nowrap"></td> : ""}
    </tr>
);

function LignesSimple(LsBalance, filtre) {
    const LignesBalance = LsBalance.map((Balance, j) => {
        return <LigneSimple key={j} {...Balance} />;
    });
    return (
        <React.Fragment>
            {LignesBalance}
        </React.Fragment>
    );
}

class PageBalance extends Component {
    state = {
        detail: false,
        filtre: 'CptBP',
        sDateExe: null,
    };

    componentDidMount(){
        if(this.props.Charges === "EN_COURS_DE_CHARGEMENT") this.props.actions.obtenirChargesExeCourant()
    }

    render() {
        const {
            Charges,
            LsBalance
        } = this.props;
        const { filtre } = this.state;
        if (estEnCoursDeChargement(Charges)) return <Chargement />;

        return (
            <React.Fragment>
                <div className="table-responsive">
                    <TableauV Entete={EnteteSimple()} Lignes={LignesSimple(LsBalance, filtre)} PetitesLignes PasDeZebrures />
                </div>
            </React.Fragment>
        );
    }
}
PageBalance.displayName = 'PageBalance';
PageBalance.requiredProps = [
    'LsBalance', //Balance de la copro
];

function mapStateToProps({
    AdhStore: { EstMembreCS },
    CopStore: {
        Cop: { LsBalance },
    },
}) {
    return {
        EstMembreCS, LsBalance
    };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(Actions, dispatch) };
}

export default connect(mapStateToPropsWrapper(mapStateToProps), mapDispatchToProps)(verificationProps(PageBalance));



// WEBPACK FOOTER //
// ./src/components/MaCopro/PageBalance.js